import { MultibrandTokenDataType } from '@/types/common';

import { setStorage } from './auth-utils';
import { SWITCH_ID_KEY } from './constants';
import { getStorageObject } from './global';

export const SWITCH_IDS_FOR_MULTI_BRAND_LOGIN = getStorageObject(SWITCH_ID_KEY) || null;

export const MULTIBRAND_TOKENS_KEY = 'multiBrandTokens';

export const MULTIBRAND_TOKENS_DATA = getStorageObject(MULTIBRAND_TOKENS_KEY) || [];

export const MULTIBRAND_TOKENS_ARRAY =
  MULTIBRAND_TOKENS_DATA.map((token: MultibrandTokenDataType) => token?.token) || [];

export const INSERT_DATA_IN_MULTIBRAND_TOKENS_DATA = (data: MultibrandTokenDataType) => {
  const currentData = getStorageObject(MULTIBRAND_TOKENS_KEY) || [];
  const checkIfExists = currentData.some(
    (multiBrandItem: MultibrandTokenDataType) => data.teamMemberId === multiBrandItem.teamMemberId
  );

  let finalData = [...currentData];

  if (!checkIfExists) {
    finalData = [...currentData, data];
    setStorage(MULTIBRAND_TOKENS_KEY, JSON.stringify(finalData));
  }

  return finalData || [];
};

export const REMOVE_DATA_FROM_MULTIBRAND_TOKENS_DATA = (teamMemberId: string) => {
  const currentData = getStorageObject(MULTIBRAND_TOKENS_KEY) || [];

  const updatedTokens = currentData.filter((token: MultibrandTokenDataType) => token.teamMemberId !== teamMemberId);

  setStorage(MULTIBRAND_TOKENS_KEY, JSON.stringify(updatedTokens));

  return updatedTokens || [];
};
